export default __webpack_public_path__ + "static/PES4-09ee20ca53df0d73744fdf727daceb07.jpg";